export default [
  {
    TipoIdentificacion: "CC",
    NumeroIdentificacion: "456",
    Nombres: "Pepe Peperoni",
    Prioritario: false,
    ConCita: false,
    Tipo: "C",
    PrioridadMarcaValor: 1
  },
  {
    TipoIdentificacion: "CC",
    NumeroIdentificacion: "123",
    Nombres: "Pepe Peperoni",
    Prioritario: false,
    ConCita: false,
    Tipo: "C",
    PrioridadMarcaValor: 1
  },
  {
    TipoIdentificacion: "CC",
    NumeroIdentificacion: "789",
    Nombres: "Natasha Cox",
    Prioritario: true,
    ConCita: true,
    Tipo: "C",
    PrioridadMarcaValor: 1
  },
  {
    TipoIdentificacion: "RC",
    NumeroIdentificacion: "789",
    Nombres: "Natasha RC",
    Prioritario: false,
    ConCita: true,
    Tipo: "C",
    PrioridadMarcaValor: 1
  },
  {
    TipoIdentificacion: "RC",
    NumeroIdentificacion: "456",
    Nombres: "Andrés RC",
    Prioritario: false,
    ConCita: false,
    Tipo: "C",
    PrioridadMarcaValor: 1
  }
];
